import React from 'react';
import '../styles/style.css'

export class Makerslist extends React.Component {
    makers (marray) {
        let makersname = [];
        for (let i=0; i<marray.length; i++) {
            makersname.push(marray[i].name);
        }
        return makersname;
    };
    render () {
        let makersarray = this.props.makerslist;
        let makersnamearray = this.makers(makersarray);
        let outputexp;
        if (makersnamearray.length === 0) {
            outputexp = <div></div>
        } else if (makersnamearray.length === 1) {
            outputexp = <p className="text-muted">{makersnamearray[0]}</p>
        } else if (makersnamearray.length === 2) {
            outputexp = (
                <div>
                    <p className="text-muted">{makersnamearray[0]}</p>
                    <p className="text-muted">{makersnamearray[1]}</p>
                </div>
            )
        } else if (makersnamearray.length === 3) {
            outputexp = (
                <div>
                    <p className="text-muted">{makersnamearray[0]}</p>
                    <p className="text-muted">{makersnamearray[1]}</p>
                    <p className="text-muted">{makersnamearray[2]}</p>
                </div>
            )
        } else {
            outputexp = (
                <div>
                    <p className="text-muted">{makersnamearray[0]}</p>
                    <p className="text-muted">{makersnamearray[1]}</p>
                    <p className="text-muted">{makersnamearray[2]}</p>
                    <h6>+{makersnamearray.length - 3} more makers</h6>
                </div>  
            )
        }
        return outputexp;
    }
};